import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import ChartAction from '../../../redux/chart/actions'
import Card from '../../../componentsMaterial/Card/Card.jsx'
import CardHeader from '../../../componentsMaterial/Card/CardHeader.jsx'
import CardBody from '../../../componentsMaterial/Card/CardBody.jsx'
import CardIcon from '../../../componentsMaterial/Card/CardIcon.jsx'
import Timeline from '@material-ui/icons/Timeline'
import { Bar } from 'react-chartjs-2'
import chartsStyle from './chartsStyle'
import withStyles from '@material-ui/core/styles/withStyles'
import { DatePicker, Icon, Tooltip, Button, Dropdown, Menu } from 'antd'
import moment from 'moment'

const { MonthPicker, RangePicker } = DatePicker

class ChartOrgTask extends Component {
    constructor(props) {
        super(props)
        var d = new Date()
        var n = d.getFullYear()
        this.state = {
            options: null,
            type: 0,
            year: n,
            month: 0,
        }
    }
    componentDidMount() {
        this.props.loadDataChartOrgTask(0, 0, 0, 0, 0)
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.chartOrgTask !== this.props.chartOrgTask) {
            const data = nextProps.chartOrgTask
            let datapoint = []
            let lstLabel = []
            data.map(value => {
                datapoint.push(value.count)
                lstLabel.push(value.name)
            })
            this.setState({
                options: {
                    labels: lstLabel,
                    datasets: [
                        {
                            label: 'Nhiệm vụ',
                            backgroundColor: 'rgba(26,115,232,0.2)',
                            borderColor: 'rgba(26,120,232,1)',
                            borderWidth: 1,
                            hoverBackgroundColor: 'rgba(26,115,232,0.4)',
                            hoverBorderColor: 'rgb(26,120,232)',
                            data: datapoint,
                        },
                    ],
                },
            })
        }
    }
    onChangeTime = e => {
        const starttime = (e[0]._d.valueOf() / 1000) >> 0
        const endtime = (e[1]._d.valueOf() / 1000) >> 0
        //
        const month = 0
        const year = 0

        this.props.loadDataChartOrgTask(
            this.state.type,
            month,
            year,
            starttime,
            endtime
        )
    }
    onChangeMonth = (date, dateString) => {
        const month = parseInt(dateString.slice(5))
        const year = parseInt(dateString.slice(0, 4))
        this.setState({ year, month })

        const begintime = 0
        const end_time = 0
        this.props.loadDataChartOrgTask(
            this.state.type,
            month,
            year,
            begintime,
            end_time
        )
    }
    getNameType = () => {
        switch (this.state.type) {
            case 0:
                return 'Chọn kiểu lọc'
            case 1:
                return 'Chọn theo tháng'
            case 2:
                return 'Chọn theo năm'
            case 3:
                return 'Chọn theo khoảng thời gian'
            default:
                return ''
            // code block
        }
    }
    disabledDate = current => {
        // Can not select days before today and today
        return current && current > moment().endOf('day')
    }
    onSelectYear = dataYear => {
        this.setState({ year: parseInt(dataYear.key) })
        const month = 0
        const begintime = 0
        const end_time = 0

        this.props.loadDataChartOrgTask(
            this.state.type,
            month,
            dataYear.key,
            begintime,
            end_time
        )
    }
    render() {
        const { classes, chartOrgTask } = this.props
        const menu = (
            <Menu>
                <Menu.Item key="1" onClick={() => this.setState({ type: 1 })}>
                    <Icon type="calendar" />
                    Lọc theo tháng
                </Menu.Item>
                <Menu.Item key="2" onClick={() => this.setState({ type: 2 })}>
                    <Icon type="calendar" />
                    Lọc theo năm
                </Menu.Item>
                <Menu.Item key="3" onClick={() => this.setState({ type: 3 })}>
                    <Icon type="calendar" />
                    Lọc theo khoảng thời gian
                </Menu.Item>
                <Menu.Item
                    key="4"
                    onClick={() => {
                        this.setState({ type: 0 })
                        const typeSelect = 0
                        const month = 0
                        const year = 0
                        const begintime = 0
                        const end_time = 0

                        this.props.loadDataChartOrgTask(
                            typeSelect,
                            month,
                            year,
                            begintime,
                            end_time
                        )
                    }}
                >
                    <Icon type="calendar" />
                    Tất cả
                </Menu.Item>
            </Menu>
        )
        const lstYear = [
            2018,
            2019,
            2020,
            2021,
            2022,
            2023,
            2024,
            2025,
            2026,
            2027,
            2028,
            2029,
            2030,
            2031,
            2032,
            2033,
            2034,
            2035,
            2036,
            2037,
            2038,
            2039,
            2040,
            2041,
            2042,
            2023,
            2044,
            2045,
            2046,
            2047,
            2048,
            2049,
            2050,
        ]
        var d = new Date()
        var n = d.getFullYear()
        const menuYearPicker = (
            <Menu>
                {lstYear.map(year => {
                    if (year <= n) {
                        return (
                            <Menu.Item
                                key={year}
                                onClick={year => this.onSelectYear(year)}
                            >
                                <Icon type="calendar" />
                                {year}
                            </Menu.Item>
                        )
                    }
                })}
            </Menu>
        )
        return (
            <div style={{ width: '100%' }}>
                <Card
                    style={{
                        backgroundImage: `url(${require('../../../resource/image/blur-bg.jpg')}`,
                        backgroundSize: 'initial',
                        backgroundPosition: 'center ',
                        height: 550,
                    }}
                >
                    <CardHeader color="rose" icon>
                        <CardIcon color="rose">
                            <Timeline />
                        </CardIcon>

                        <h4
                            className={classes.cardIconTitle}
                            style={{ color: 'white' }}
                        >
                            Thống kê nhiệm vụ theo đơn vị
                        </h4>
                    </CardHeader>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        }}
                    >
                        <Dropdown overlay={menu}>
                            <Button style={{ marginRight: 20 }}>
                                {this.getNameType()}
                                <Icon type="down" />
                            </Button>
                        </Dropdown>
                        {this.state.type === 2 && (
                            <Dropdown overlay={menuYearPicker}>
                                <Button style={{ marginRight: 20 }}>
                                    {this.state.year}
                                    <Icon
                                        type="down"
                                        style={{ paddingLeft: 10 }}
                                    />
                                </Button>
                            </Dropdown>
                        )}

                        {this.state.type === 1 && (
                            <div>
                                <MonthPicker
                                    onChange={this.onChangeMonth}
                                    disabledDate={this.disabledDate}
                                    style={{ padding: 10 }}
                                    placeholder="Chọn tháng"
                                />
                            </div>
                        )}

                        {this.state.type === 3 && (
                            <div>
                                <RangePicker
                                    format="DD/MM/YYYY"
                                    renderExtraFooter={() =>
                                        'Hiển thị biểu đồ theo thời gian'
                                    }
                                    onChange={this.onChangeTime}
                                    placeholder={[
                                        'Thời gian đầu',
                                        'Thời gian cuối',
                                    ]}
                                    showTime
                                    style={{ padding: 10 }}
                                />
                            </div>
                        )}
                    </div>

                    <CardBody>
                        <div>
                            <text style={{ color: 'white' }}>
                                Số lượng nhiệm vụ
                            </text>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    width: '100%',
                                    alignItems: 'flex-end',
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    {this.state.options && (
                                        <Bar
                                            data={this.state.options}
                                            height={400}
                                            width={500}
                                            options={{
                                                maintainAspectRatio: false,
                                                legend: {
                                                    display: true,
                                                    labels: {
                                                        fontColor: 'white',
                                                    },
                                                },
                                                scales: {
                                                    yAxes: [
                                                        {
                                                            ticks: {
                                                                fontColor:
                                                                    'white',
                                                            },
                                                        },
                                                    ],
                                                    xAxes: [
                                                        {
                                                            ticks: {
                                                                fontColor:
                                                                    'white',
                                                            },
                                                        },
                                                    ],
                                                },
                                                tooltips: {
                                                    callbacks: {
                                                        label: function (
                                                            tooltipItem
                                                        ) {
                                                            return (
                                                                tooltipItem.value +
                                                                ' nhiệm vụ đã thực hiện'
                                                            )
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        chartOrgTask: state.chartReducer.chartOrgTask,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadDataChartOrgTask: (
            typeSelect,
            month,
            year,
            begin_time,
            end_time
        ) => {
            dispatch(
                ChartAction.action.loadDataChartOrgTask(
                    typeSelect,
                    month,
                    year,
                    begin_time,
                    end_time
                )
            )
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(chartsStyle)(ChartOrgTask))
